import Rest from '@/services/Rest';

/**
 * @typedef {SetupPasswordService}
 */
export default class SetupPasswordService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/extern/setup-password'
}
